// extracted by mini-css-extract-plugin
export default {"title":"NoSiteSearchResults_title__IynZn","text":"NoSiteSearchResults_text__jUUHD"};